import React from 'react';
import { Card, Stack } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IEvent } from '../../types/global/helper';
import { CutomReadMore } from '../ReadMore/CutomReadMore';
import { InfoOutlined } from '@mui/icons-material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon';
import { ThspianAvatar } from '../Avatar/ThspianAvatar';

export interface IEventDescripiton {
    event: IEvent;
}

const EventHost: React.FC<IEventDescripiton> = ({ event }) => {
    const { themeStyle } = useThemeContext();
    return (
        <React.Fragment>
            <Stack direction="row" gap={1}>
                <TextWithIcon text="About Host" icon={<InfoOutlined sx={{ color: theme[themeStyle].tag_white }} />} />
            </Stack>

            <Card
                sx={{
                    width: '100%',
                    borderRadius: 1,
                    overflow: 'visible',
                    my: 2,
                    p: 1,
                    height: 'fit-content',
                    backgroundColor: theme[themeStyle].secondaryBg,
                    border: `0.3px solid ${theme[themeStyle].highlight}`,
                }}>
                <Stack direction="row" alignItems="flex-start" gap={2}>
                    <ThspianAvatar user={event.created_by} />
                    <CutomReadMore
                        text={event.about_host!}
                        maxChars={150}
                        maxLines={2}
                        sx={{
                            fontSize: 14,
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            color: theme[themeStyle].tag_white,
                        }}
                    />
                </Stack>
            </Card>
        </React.Fragment>
    );
};

export { EventHost };
